module.exports = __webpack_public_path__ + "img/bg-play.b278b9ba.png";